// src/pages/OpdPataintList.js - COMPLETE VERSION
import React, { useEffect, useState, useRef, useMemo } from "react";
import AppConst from "../apis/appconst";
import axios from "axios";
import 'bootstrap/dist/css/bootstrap.min.css';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { toast } from "react-toastify";
import DataTable from 'react-data-table-component';
import Swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import Select from "react-select";
import { Modal, Tab, Tabs } from 'react-bootstrap';

function OpdPataintList() {
  const todayDate = (() => {
    const d = new Date();
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    const dd = String(d.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  })();
  const [selectedDoctorFilter, setSelectedDoctorFilter] = useState('');
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [openDropdownId, setOpenDropdownId] = useState(null);
  const [headerLogo, setHeaderLogo] = useState('');
  const [watermarkLogo, setWatermarkLogo] = useState('');
  const [footerImage, setFooterImage] = useState('');
  const [isAdmin, setIsAdmin] = useState(false);
  const [doctorsMap, setDoctorsMap] = useState({});
  const dropdownRefs = useRef([]);
  const [isDoctorLogin, setIsDoctorLogin] = useState(false);
  const [loggedDoctorId, setLoggedDoctorId] = useState('')
  const [pageNo, setPageNo] = useState(0);
  const [pageSize, setPageSize] = useState(15);
  const [totalCount, setTotalCount] = useState(0);

  // Medicine states
  const [medicineList, setMedicineList] = useState([]);
  const [medicineOptions, setMedicineOptions] = useState([]);
  const [isPrescriptionSaved, setIsPrescriptionSaved] = useState(false);
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  // Investigation states
  const [investigationList, setInvestigationList] = useState([]);
  const [investigationOptions, setInvestigationOptions] = useState([]);

  // Prescription modal states
  const [showPrescriptionModal, setShowPrescriptionModal] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [activeTab, setActiveTab] = useState('patient');
  
  const [prescriptionData, setPrescriptionData] = useState({

    next_visit_days: '',
    vitals: [{
      sn: 1,
      vital_name: '',
      vital_value: ''
    }],
    medicines: [{
      sn: 1,
      medicine_name: '',
      medicine_id: '',
      batch: '',
      expiry: '',
      morning: '',
      noon: '',
      evening: '',
      night: '',
      days: '',
      qty: '',
      start_date: new Date().toISOString().split('T')[0],
      end_date: '',
      instructions: ''
    }],
    complaints: [{
      sn: 1,
      complaint_text: ''
    }],
    investigations: [{
      sn: 1,
      investigation_id: '',
      investigation_name: '',
      notes: ''
    }]
   
  });

  const [formData, setFormData] = useState({
    l1: [],
    doc: [],
    vitals: [],
    page_no: 0,
    from: todayDate,
    to: todayDate,
    alertMsg: '',
    alertMsgTyp: '',
    search_key: '',
    isAlert: false,
    selectedDoctorId: ''
  });

  const [totals, setTotals] = useState({
    totalAmount: 0,
    discountAmount: 0,
    paidAmount: 0,
    dueAmount: 0,
    totalCharges: 0
  });

  const [ldata, setLdata] = useState(null);
  const getCurrentDateTime = () => {
    const now = new Date();
    return now.toLocaleString('en-GB', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };
  
  // ============================================
  // LOAD MEDICINES FROM PURCHASE LIST
  // ============================================
  const loadMedicineList = async () => {
    try {
      const fd = new FormData();
      fd.append('page_no', '0');
      fd.append('search_key', '');
      fd.append('purchase_type', 'normal');

      const response = await axios.post(
        AppConst.BASE_URL + AppConst.getPurchaseListUrl,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response.data.status) {
        const records = response.data.records;
        if (records && Array.isArray(records)) {
          let allMedicines = [];
          records.forEach((rec) => {
            if (rec.items && Array.isArray(rec.items)) {
              allMedicines = [...allMedicines, ...rec.items];
            }
          });
          
          setMedicineList(allMedicines);
          
          const medicineGroups = allMedicines.reduce((acc, m) => {
            if (!acc[m.purchase_item_medicine]) {
              acc[m.purchase_item_medicine] = {
                ...m,
                batches: [],
                total_stock: 0
              };
            }
            const batchStock = parseInt(m.purchase_item_qty_stock || 0);
            acc[m.purchase_item_medicine].batches.push(m);
            acc[m.purchase_item_medicine].total_stock += batchStock;
            return acc;
          }, {});

          const options = Object.values(medicineGroups)
            .filter(group => group.total_stock > 0)
            .map(m => {
              const bestBatch = m.batches
                .filter(b => parseInt(b.purchase_item_qty_stock || 0) > 0)
                .sort((a, b) => {
                  const expA = `${a.purchase_item_expiry_year}-${String(a.purchase_item_expiry_month).padStart(2, '0')}`;
                  const expB = `${b.purchase_item_expiry_year}-${String(b.purchase_item_expiry_month).padStart(2, '0')}`;
                  return expB.localeCompare(expA);
                })[0];

              const expMonthName = bestBatch?.purchase_item_expiry_month
                ? monthNames[parseInt(bestBatch.purchase_item_expiry_month) - 1]
                : "";

              return {
                value: bestBatch?.purchase_item_id || m.purchase_item_id,
                label: m.purchase_item_medicine,
                batch: bestBatch?.purchase_item_batch || '',
                expiry: expMonthName ? `${expMonthName}-${bestBatch?.purchase_item_expiry_year}` : 'N/A',
                stock: m.total_stock,
                medicineData: bestBatch || m
              };
            });

          setMedicineOptions(options);
        }
      }
    } catch (error) {
      console.error("Error loading medicines:", error);
      toast.error("Failed to load medicines");
    }
  };
  const doctorOptions = useMemo(() => {
    const map = new Map();
  
    // 1) prefer explicit doctor list from backend (formData.doc)
    if (Array.isArray(formData.doc)) {
      formData.doc.forEach((d, i) => {
        try {
          const id = d?.user_id ?? d?.id ?? d?.userId ?? d?.doctor_id ?? d?.doc?.doc_parent ?? d?.doc?.doc_id ?? d?.doc?.doc_user ?? `doc_backend_${i}`;
          const fname = d?.fname || '';
          const lname = d?.lname || '';
          const fullName = `${fname} ${lname}`.trim();
          const label = fullName || d?.name || d?.full_name || d?.username || d?.doc?.doc_name || String(id);
          if (id != null && String(id).trim() !== "" && label) map.set(String(id), label.trim());
        } catch (e) { /* ignore malformed */ }
      });
    }
  
    // convert to sorted array (by label)
    const arr = Array.from(map.entries()).map(([value, label]) => ({ value, label }));
    arr.sort((a, b) => a.label.localeCompare(b.label));
    return arr;
  }, [formData.doc]);
  // ============================================
  // LOAD INVESTIGATIONS FROM TEST LIST
  // ============================================
  const loadInvestigationList = async () => {
    try {
      const fd = new FormData();
      fd.append('type', 'test');
      fd.append('search_key', '');
      fd.append('page_no', 'none');
      fd.append('test_user', '1');

      const response = await axios.post(
        AppConst.BASE_URL + AppConst.getTestListUrl,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response.data.status) {
        const records = response.data.records || [];
        setInvestigationList(records);
        
        const options = records.map(test => ({
          value: test.test_id || test.id,
          label: test.test_name || test.name,
          price: test.test_price || test.price || 0,
          category: test.cat_name || ''
        }));
        
        setInvestigationOptions(options);
      }
    } catch (error) {
      console.error("Error loading investigations:", error);
      toast.error("Failed to load investigations");
    }
  };

  // ============================================
  // MEDICINE SELECTION HANDLER
  // ============================================
  const handleMedicineSelectChange = (selectedOption, index) => {
    if (!selectedOption) {
      handleMedicineChange(index, 'medicine_name', '');
      handleMedicineChange(index, 'medicine_id', '');
      handleMedicineChange(index, 'batch', '');
      handleMedicineChange(index, 'expiry', '');
      return;
    }

    setPrescriptionData(prev => {
      const updatedMedicines = [...prev.medicines];
      updatedMedicines[index] = {
        ...updatedMedicines[index],
        medicine_name: selectedOption.label,
        medicine_id: selectedOption.value,
        batch: selectedOption.batch,
        expiry: selectedOption.expiry
      };
      return { ...prev, medicines: updatedMedicines };
    });
  };

  // ============================================
  // INVESTIGATION SELECTION HANDLER
  // ============================================
  const handleInvestigationSelectChange = (selectedOption, index) => {
    if (!selectedOption) {
      handleInvestigationChange(index, 'investigation_id', '');
      handleInvestigationChange(index, 'investigation_name', '');
      return;
    }

    setPrescriptionData(prev => {
      const updatedInvestigations = [...prev.investigations];
      updatedInvestigations[index] = {
        ...updatedInvestigations[index],
        investigation_id: selectedOption.value,
        investigation_name: selectedOption.label
      };
      return { ...prev, investigations: updatedInvestigations };
    });
  };

  // ============================================
  // MEDICINE CHANGE HANDLER
  // ============================================
  const handleMedicineChange = (index, field, value) => {
    setPrescriptionData(prev => {
      const updatedMedicines = prev.medicines.map((med, i) => {
        if (i !== index) return med;

        const updated = { ...med, [field]: value };

        if (['morning', 'noon', 'evening', 'night', 'days'].includes(field)) {
          const morning = parseFloat(updated.morning || 0);
          const noon = parseFloat(updated.noon || 0);
          const evening = parseFloat(updated.evening || 0);
          const night = parseFloat(updated.night || 0);
          const days = parseInt(updated.days || 0);

          const dailyDose = morning + noon + evening + night;
          const totalQty = dailyDose * days;

          updated.qty = totalQty > 0 ? totalQty.toFixed(0) : '';
        }

        if (field === 'days' && value) {
          const startDate = new Date(updated.start_date || new Date());
          const days = parseInt(value) || 0;
          const endDate = new Date(startDate);
          endDate.setDate(endDate.getDate() + days - 1);
          updated.end_date = endDate.toISOString().split('T')[0];
        }

        if (field === 'start_date' && updated.days) {
          const startDate = new Date(value);
          const days = parseInt(updated.days) || 0;
          const endDate = new Date(startDate);
          endDate.setDate(endDate.getDate() + days - 1);
          updated.end_date = endDate.toISOString().split('T')[0];
        }

        return updated;
      });

      return { ...prev, medicines: updatedMedicines };
    });
  };

  // ============================================
  // ROW MANAGEMENT FUNCTIONS
  // ============================================
  
  // Vital rows
  const addVitalRow = () => {
    setPrescriptionData(prev => ({
      ...prev,
      vitals: [...prev.vitals, {
        sn: prev.vitals.length + 1,
        vital_name: '',
        vital_value: ''
      }]
    }));
  };

  const removeVitalRow = (index) => {
    setPrescriptionData(prev => ({
      ...prev,
      vitals: prev.vitals.filter((_, i) => i !== index)
    }));
  };

  const handleVitalChange = (index, field, value) => {
    setPrescriptionData(prev => ({
      ...prev,
      vitals: prev.vitals.map((vital, i) => 
        i === index ? { ...vital, [field]: value } : vital
      )
    }));
  };

  // Medicine rows
  const addMedicineRow = () => {
    setPrescriptionData(prev => ({
      ...prev,
      medicines: [...prev.medicines, {
        sn: prev.medicines.length + 1,
        medicine_name: '',
        medicine_id: '',
        batch: '',
        expiry: '',
        morning: '',
        noon: '',
        evening: '',
        night: '',
        days: '',
        qty: '',
        start_date: new Date().toISOString().split('T')[0],
        end_date: '',
        instructions: ''
      }]
    }));
  };

  const removeMedicineRow = (index) => {
    setPrescriptionData(prev => ({
      ...prev,
      medicines: prev.medicines.filter((_, i) => i !== index)
    }));
  };

  // Complaint rows
  const addComplaintRow = () => {
    setPrescriptionData(prev => ({
      ...prev,
      complaints: [...prev.complaints, {
        sn: prev.complaints.length + 1,
        complaint_text: ''
      }]
    }));
  };

  const removeComplaintRow = (index) => {
    setPrescriptionData(prev => ({
      ...prev,
      complaints: prev.complaints.filter((_, i) => i !== index)
    }));
  };

  const handleComplaintChange = (index, value) => {
    setPrescriptionData(prev => ({
      ...prev,
      complaints: prev.complaints.map((complaint, i) => 
        i === index ? { ...complaint, complaint_text: value } : complaint
      )
    }));
  };

  // Investigation rows
  const addInvestigationRow = () => {
    setPrescriptionData(prev => ({
      ...prev,
      investigations: [...prev.investigations, {
        sn: prev.investigations.length + 1,
        investigation_id: '',
        investigation_name: '',
        notes: ''
      }]
    }));
  };

  const removeInvestigationRow = (index) => {
    setPrescriptionData(prev => ({
      ...prev,
      investigations: prev.investigations.filter((_, i) => i !== index)
    }));
  };

  const handleInvestigationChange = (index, field, value) => {
    setPrescriptionData(prev => ({
      ...prev,
      investigations: prev.investigations.map((inv, i) => 
        i === index ? { ...inv, [field]: value } : inv
      )
    }));
  };

  // ============================================
  // OPEN PRESCRIPTION MODAL
  // ============================================


 // ============================================
// FETCH SAVED PRESCRIPTION DATA
// ============================================
const fetchPrescriptionData = async (opdId) => {
  try {
    const fd = new FormData();
    fd.append('opd_id', opdId);

    const response = await axios.post(
      AppConst.BASE_URL + AppConst.getPrescriptionUrl,
      fd,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );

    if (response.data.status) {
      const { vitals, complaints, medicines, investigations } = response.data;
      
      // Transform vitals
      const transformedVitals = vitals.length > 0 
        ? vitals.map((v, index) => ({
            sn: index + 1,
            vital_name: v.opd_vital_name || '',
            vital_value: v.opd_vital_value || ''
          }))
        : [{
            sn: 1,
            vital_name: '',
            vital_value: ''
          }];

      // Transform complaints
      const transformedComplaints = complaints.length > 0
        ? complaints.map((c, index) => ({
            sn: index + 1,
            complaint_text: c.opd_complaint_text || ''
          }))
        : [{
            sn: 1,
            complaint_text: ''
          }];

      // Transform medicines
      const transformedMedicines = medicines.length > 0
        ? medicines.map((m, index) => ({
            sn: index + 1,
            medicine_name: m.opd_medicine_name || '',
            medicine_id: m.opd_medicine_id_ref || '',
            batch: m.opd_medicine_batch || '',
            expiry: m.opd_medicine_expiry || '',
            morning: m.opd_medicine_morning || '',
            noon: m.opd_medicine_noon || '',
            evening: m.opd_medicine_evening || '',
            night: m.opd_medicine_night || '',
            days: m.opd_medicine_days || '',
            qty: m.opd_medicine_qty || '',
            start_date: m.opd_medicine_start_date || new Date().toISOString().split('T')[0],
            end_date: m.opd_medicine_end_date || '',
            instructions: m.opd_medicine_instructions || ''
          }))
        : [{
            sn: 1,
            medicine_name: '',
            medicine_id: '',
            batch: '',
            expiry: '',
            morning: '',
            noon: '',
            evening: '',
            night: '',
            days: '',
            qty: '',
            start_date: new Date().toISOString().split('T')[0],
            end_date: '',
            instructions: ''
          }];

      // Transform investigations
      const transformedInvestigations = investigations.length > 0
        ? investigations.map((i, index) => ({
            sn: index + 1,
            investigation_id: i.opd_investigation_id_ref || '',
            investigation_name: i.opd_investigation_name || '',
            notes: i.opd_investigation_notes || ''
          }))
        : [{
            sn: 1,
            investigation_id: '',
            investigation_name: '',
            notes: ''
          }];

      // Update prescription data
      setPrescriptionData({
        vitals: transformedVitals,
        complaints: transformedComplaints,
        medicines: transformedMedicines,
        investigations: transformedInvestigations,
        next_visit_days: response.data.next_visit_days || ''
      });

      toast.success('Previous prescription data loaded');
    } else {
      // No saved data - use empty defaults
      setPrescriptionData({
        vitals: [{ sn: 1, vital_name: '', vital_value: '' }],
        complaints: [{ sn: 1, complaint_text: '' }],
        medicines: [{
          sn: 1,
          medicine_name: '',
          medicine_id: '',
          batch: '',
          expiry: '',
          morning: '',
          noon: '',
          evening: '',
          night: '',
          days: '',
          qty: '',
          start_date: new Date().toISOString().split('T')[0],
          end_date: '',
          instructions: ''
        }],
        investigations: [{ sn: 1, investigation_id: '', investigation_name: '', notes: '' }]
      });
    }
  } catch (err) {
    console.error('Error fetching prescription data:', err);
    toast.warning('No previous prescription found - starting fresh');
    
    // Use empty defaults on error
    setPrescriptionData({
      vitals: [{ sn: 1, vital_name: '', vital_value: '' }],
      complaints: [{ sn: 1, complaint_text: '' }],
      medicines: [{
        sn: 1,
        medicine_name: '',
        medicine_id: '',
        batch: '',
        expiry: '',
        morning: '',
        noon: '',
        evening: '',
        night: '',
        days: '',
        qty: '',
        start_date: new Date().toISOString().split('T')[0],
        end_date: '',
        instructions: ''
      }],
      investigations: [{ sn: 1, investigation_id: '', investigation_name: '', notes: '' }]
    });
  }
};

// ============================================
// UPDATED: Open Prescription Modal
// ============================================
const openPrescriptionModal = async (row) => {
  setSelectedPatient(row);
  setShowPrescriptionModal(true);
  setActiveTab('patient');
  setIsPrescriptionSaved(false);
  
  // Load medicine and investigation options
  loadMedicineList();
  loadInvestigationList();
  
  // Fetch saved prescription data
  await fetchPrescriptionData(row.opd_id);
};

// ============================================
// UPDATED: Close Prescription Modal
// ============================================
const closePrescriptionModal = () => {
  // Close any open Select dropdowns first
  const activeElement = document.activeElement;
  if (activeElement && activeElement.blur) {
    activeElement.blur();
  }
  
  setTimeout(() => {
    setShowPrescriptionModal(false);
    setSelectedPatient(null);
    setIsPrescriptionSaved(false);
    setActiveTab('patient');
    
    // Reset to empty state
    setPrescriptionData({
      vitals: [{ sn: 1, vital_name: '', vital_value: '' }],
      complaints: [{ sn: 1, complaint_text: '' }],
      medicines: [{
        sn: 1,
        medicine_name: '',
        medicine_id: '',
        batch: '',
        expiry: '',
        morning: '',
        noon: '',
        evening: '',
        night: '',
        days: '',
        qty: '',
        start_date: new Date().toISOString().split('T')[0],
        end_date: '',
        instructions: ''
      }],
      investigations: [{ sn: 1, investigation_id: '', investigation_name: '', notes: '' }]
    });
  }, 150);
};

  // ============================================
  // SAVE PRESCRIPTION
  // ============================================
  const savePrescription = async () => {
    if (!selectedPatient) {
      toast.error("No patient selected");
      return;
    }

    try {
      const fd = new FormData();
      fd.append('opd_id', selectedPatient.opd_id);
      
      // Prepare vitals data
      const vitalsData = prescriptionData.vitals
        .filter(v => v.vital_name && v.vital_value)
        .map(v => ({
          vital_name: v.vital_name,
          vital_value: v.vital_value
        }));
      
      // Prepare complaints data
      const complaintsData = prescriptionData.complaints
        .filter(c => c.complaint_text && c.complaint_text.trim())
        .map(c => ({
          complaint_text: c.complaint_text
        }));

      // Prepare medicines data
      const medicinesData = prescriptionData.medicines
        .filter(m => m.medicine_name)
        .map(m => ({
          medicine_name: m.medicine_name,
          medicine_id: m.medicine_id,
          batch: m.batch,
          expiry: m.expiry,
          morning: m.morning || '0',
          noon: m.noon || '0',
          evening: m.evening || '0',
          night: m.night || '0',
          days: m.days || '0',
          qty: m.qty || '0',
          start_date: m.start_date,
          end_date: m.end_date,
          instructions: m.instructions || ''
        }));

      // Prepare investigations data
      const investigationsData = prescriptionData.investigations
        .filter(i => i.investigation_name)
        .map(i => ({
          investigation_id: i.investigation_id,
          investigation_name: i.investigation_name,
          notes: i.notes || ''
        }));

      fd.append('vitals', JSON.stringify(vitalsData));
      fd.append('complaints', JSON.stringify(complaintsData));
      fd.append('medicines', JSON.stringify(medicinesData));
      fd.append('investigations', JSON.stringify(investigationsData));
      fd.append('user_id', ldata?.user_id || 1);
      fd.append('next_visit_days', prescriptionData.next_visit_days || '');

      const markOpdDoneFromPrescription = async (opdId) => {
        try {
          const fd = new FormData();
          fd.append('opd_id', String(opdId));
          fd.append('done', '1');
      
          const resp = await axios.post(
            AppConst.BASE_URL + AppConst.updateOpdDoneUrl,
            fd,
            { headers: { 'Content-Type': 'multipart/form-data' } }
          );
      
          if (resp?.data?.status) {
            // ✅ update UI after DB success
            setFormData(prev => ({
              ...prev,
              l1: (prev.l1 || []).map(r =>
                r.opd_id === opdId ? { ...r, done: 1 } : r
              )
            }));
          } else {
            toast.error(resp?.data?.error || 'Failed to mark OPD done');
          }
        } catch (err) {
          console.error("markOpdDoneFromPrescription error:", err);
          toast.error("Network error while marking done");
        }
      };
      
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.savePrescriptionUrl,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response.data.status) {
        toast.success('Prescription saved successfully!');
        setIsPrescriptionSaved(true);
      
        // Mark OPD as done in backend
        await markOpdDone(selectedPatient.opd_id);
      
        // 🔥 UPDATE UI STATE IMMEDIATELY
        setFormData(prev => ({
          ...prev,
          l1: prev.l1.map(row =>
            row.opd_id === selectedPatient.opd_id
              ? { ...row, done: 1 }
              : row
          )
        }));
      }
       else {
        toast.error(response.data.message || 'Failed to save prescription');
      }
    } catch (err) {
      console.error('Error saving prescription:', err);
      toast.error('Failed to save prescription');
    }
  };

  // ============================================
  // MARK OPD AS DONE
  // ============================================
  const markOpdDone = async (opdId) => {
    try {
      const fd = new FormData();
      fd.append('opd_id', opdId);
      fd.append('done', '1');

      const response = await axios.post(
        AppConst.BASE_URL + AppConst.updateOpdDoneUrl,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );

      if (response.data.status) {
        console.log('OPD marked as done');
      }
    } catch (err) {
      console.error('Error marking OPD as done:', err);
    }
  };

  // ============================================
  // PRINT PRESCRIPTION PDF
  // ============================================
  const printPrescription = async () => {
    if (!selectedPatient) return;
  
    // ✅ FIND DOCTOR FROM formData.doc ARRAY
    const selectedDoctor = formData.doc.find(
      doc => String(doc.user_id) === String(selectedPatient.opd_concult_doctor)
    );
  
    // ✅ BUILD DOCTOR INFO WITH MULTIPLE FALLBACKS
    const doctorName = (() => {
      if (selectedDoctor) {
        const fname = selectedDoctor.fname || '';
        const lname = selectedDoctor.lname || '';
        return `${fname} ${lname}`.trim();
      }
      return selectedPatient.consult_doctor_name || getDoctorNameById(selectedPatient.opd_concult_doctor) || 'N/A';
    })();
  
    const doctorDegree = selectedDoctor?.doc?.doc_degree || selectedDoctor?.doc?.degree || '';
    
    const doctorSpeciality = selectedDoctor?.doc?.doc_specality 
      || selectedDoctor?.doc?.doc_speciality 
      || selectedDoctor?.doc?.speciality 
      || '';
    
    const doctorRegNo = selectedDoctor?.doc?.doc_reg_number 
      || selectedDoctor?.doc?.doc_reg_no 
      || selectedDoctor?.doc?.registration_number 
      || 'N/A';
  
    // ✅ FORMAT DATE PROPERLY
    
    const formattedDateTime = getCurrentDateTime();
 
    const prescriptionPdfData = {
      config: { headerLogoUrl: headerLogo },
      patient: {
        uhid: selectedPatient.opd_uhid || 'N/A',
        name: `${selectedPatient.opd_patient_title || ''} ${selectedPatient.opd_patient_name || ''}`.trim(),
        address: selectedPatient.opd_address || 'N/A',
        age: selectedPatient.opd_guardien_age || 'N/A',
        sex: selectedPatient.opd_patient_gender || 'N/A',
        mobile: selectedPatient.opd_patient_mobile || 'N/A'
      },
      bill: {
        opdNo: selectedPatient.opd_id || 'N/A',
        date: formattedDateTime
      },
      doctor: {
        name: doctorName,
        degree: doctorDegree,
        speciality: doctorSpeciality,
        regNo: doctorRegNo
      },
      vitals: prescriptionData.vitals.filter(v => v.vital_name && v.vital_value),
      complaints: prescriptionData.complaints.filter(c => c.complaint_text),
      medicines: prescriptionData.medicines.filter(m => m.medicine_name),
      investigations: prescriptionData.investigations.filter(i => i.investigation_name),
      nextVisitDays: prescriptionData.next_visit_days
    };
  
    await generatePrescriptionPdfNew(prescriptionPdfData);
  };
const modalCustomStyles = `
<style>
/* Increase dropdown menu height for Select components */
.medicine-select .select__menu,
.investigation-select .select__menu {
    max-height: 300px !important; /* Increased from default 200px */
}

.medicine-select .select__menu-list,
.investigation-select .select__menu-list {
    max-height: 280px !important;
    overflow-y: auto;
}

/* Ensure dropdown appears above other elements */
.medicine-select .select__menu,
.investigation-select .select__menu {
    z-index: 9999 !important;
}

/* Better spacing for option items */
.medicine-select .select__option,
.investigation-select .select__option {
    padding: 10px 12px !important;
    min-height: 50px;
}
</style>
`;

  // ============================================
  // GENERATE PRESCRIPTION PDF
  // ============================================
  const generatePrescriptionPdfNew = async (data) => {
    const doc = new jsPDF('p', 'pt', 'a4');
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const margin = 40;

    // ================= A. Header Logo =================
    const headerImageBase64 = await imageUrlToBase64(data.config.headerLogoUrl);
    if (headerImageBase64) {
        doc.addImage(headerImageBase64, 'PNG', 0, 0, pageWidth, 80);
    }

    // ================= B. Prescription Heading Box =================
    doc.setFontSize(10);
    doc.setFont('helvetica', 'bold');
    doc.setDrawColor(0);
    doc.setLineWidth(1.5);
    doc.rect(margin, 90, pageWidth - (margin * 2), 25);
    doc.text("OPD PRESCRIPTION", pageWidth / 2, 107, { align: 'center' });

    // ================= C. Patient & Visit Details =================
    let y = 135;
    const rowHeight = 18;
    const labelWidth = 65;

    const printDetail = (label, value, x, yPos) => {
        doc.setFontSize(9);
        doc.setFont('helvetica', 'bold');
        doc.text(label, x, yPos);
        doc.setFont('helvetica', 'normal');
        doc.text(`:  ${value || ''}`, x + labelWidth, yPos);
    };

    const col1X = margin + 5;
    const col2X = margin + 220;
    const col3X = margin + 380;

    printDetail("UHID No", data.patient.uhid, col1X, y);
    printDetail("OPD No", data.bill.opdNo, col2X, y);
    printDetail("Date", data.bill.date, col3X, y);
    y += rowHeight;

    printDetail("Name", data.patient.name, col1X, y);
    printDetail("Age", data.patient.age, col2X, y);
    printDetail("Sex", data.patient.sex, col3X, y);
    y += rowHeight;

    printDetail("Address", data.patient.address, col1X, y);
    printDetail("Mobile No", data.patient.mobile, col2X, y);
    y += rowHeight;

    // Doctor details with degree and speciality
    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.text("Doctor", col1X, y);
    doc.setFont('helvetica', 'normal');
    const doctorText = `:  ${data.doctor.name || ''} ${data.doctor.degree ? '(' + data.doctor.degree + ')' : ''} ${data.doctor.speciality ? '(' + data.doctor.speciality + ')' : ''}`;
    const doctorDetails = doc.splitTextToSize(doctorText, 350);
    doc.text(doctorDetails, col1X + labelWidth, y);
    //printDetail("Doctor Reg No", data.doctor.regNo, col3X, y);

    y += rowHeight;
    doc.setLineWidth(0.8);
    doc.line(0, y, pageWidth, y); // Full width horizontal line

    // ================= D. Main Content Area =================
    let contentStartY = y + 30;
    const leftSectionWidth = 150;

    // Vertical divider
    doc.setLineWidth(1.5);
    doc.line(leftSectionWidth, y, leftSectionWidth, pageHeight - margin - 20);

    // Horizontal dividers for left section
    const complaintsY = contentStartY + 120;
    doc.setLineWidth(0.5);
    doc.line(margin, complaintsY, leftSectionWidth, complaintsY);

    // Section Titles (Left Side)
    doc.setFontSize(9);
    doc.setFont('helvetica', 'bold');
    doc.text("VITALS :", margin + 5, contentStartY + 1);
    doc.text("Complaint :", margin + 5, complaintsY + 15);

    // Rx Section (Right Side)
    doc.setFontSize(22);
    doc.setFont('times', 'bold');
    doc.text("Rx", leftSectionWidth + 15, contentStartY + 5);

    // ================= E. Left Section - Vitals & Complaints =================
    const leftColX = margin + 5;
    const leftColWidth = leftSectionWidth - margin - 10;
    const itemFontSize = 8;
    doc.setFontSize(itemFontSize);
    doc.setFont('helvetica', 'normal');

    // --- Vitals Data ---
    let vitalsY = contentStartY + 15;
    if (data.vitals && data.vitals.length > 0) {
        data.vitals.forEach((vital, idx) => {
            const vitalName = formData.vitals.find(v => v.cat_id == vital.vital_name)?.cat_name || vital.vital_name;
            const text = `${idx + 1}. ${vitalName}: ${vital.vital_value}`;
            const wrappedText = doc.splitTextToSize(text, leftColWidth);
            
            if (vitalsY + (wrappedText.length * (itemFontSize + 2)) < complaintsY - 5) {
                doc.text(wrappedText, leftColX, vitalsY);
                vitalsY += wrappedText.length * (itemFontSize + 2);
            }
        });
    }

    // --- Complaints Data ---
    let complaintsStartY = complaintsY + 30;
    if (data.complaints && data.complaints.length > 0) {
        data.complaints.forEach((complaint, idx) => {
            const text = `${idx + 1}. ${complaint.complaint_text}`;
            const wrappedText = doc.splitTextToSize(text, leftColWidth);
            
            doc.text(wrappedText, leftColX, complaintsStartY);
            complaintsStartY += wrappedText.length * (itemFontSize + 2);
        });
    }

    // ================= F. Right Section - Medicines Table =================
    let medicineStartY = contentStartY + 25;
    
    if (data.medicines && data.medicines.length > 0) {
        doc.setFontSize(9);
        doc.setFont('helvetica', 'bold');
        doc.text("MEDICINES:", leftSectionWidth + 15, medicineStartY);
        medicineStartY += 15;

        // Medicine Table with Start Date and End Date (NO Instructions column)
        autoTable(doc, {
            startY: medicineStartY,
            head: [['S.No', 'Medicine Name', 'M-N-E-Nt', 'Days', 'Qty', 'Start Date', 'End Date']],
            body: data.medicines.map((med, idx) => [
                idx + 1,
                med.medicine_name || 'N/A',
                `${med.morning || 0}-${med.noon || 0}-${med.evening || 0}-${med.night || 0}`,
                med.days || '',
                med.qty || '',
                med.start_date ? formatDateDDMMYYYY(med.start_date) : '',
                med.end_date ? formatDateDDMMYYYY(med.end_date) : ''
            ]),
            theme: 'grid',
            headStyles: { 
                fillColor: [200, 200, 200], 
                textColor: 0,
                fontSize: 8,
                fontStyle: 'bold'
            },
            bodyStyles: {
                fontSize: 8,
                textColor: 0
            },
            columnStyles: {
                0: { cellWidth: 30, halign: 'center' },  // S.No
                1: { cellWidth: 150 },                    // Medicine Name
                2: { cellWidth: 50, halign: 'center' },   // M-N-E-Nt
                3: { cellWidth: 35, halign: 'center' },   // Days
                4: { cellWidth: 35, halign: 'center' },   // Qty
                5: { cellWidth: 60, halign: 'center' },   // Start Date
                6: { cellWidth: 60, halign: 'center' }    // End Date
            },
            margin: { left: leftSectionWidth + 15, right: margin },
            tableWidth: 'auto'
        });

        medicineStartY = doc.lastAutoTable.finalY + 20;
    }

    // ================= G. Investigations Table =================
    if (data.investigations && data.investigations.length > 0) {
        doc.setFontSize(9);
        doc.setFont('helvetica', 'bold');
        doc.text("INVESTIGATIONS:", leftSectionWidth + 15, medicineStartY);
        medicineStartY += 15;

        autoTable(doc, {
            startY: medicineStartY,
            head: [['S.No', 'Investigation Name', 'Notes']],
            body: data.investigations.map((inv, idx) => [
                idx + 1,
                inv.investigation_name || 'N/A',
                inv.notes || ''
            ]),
            theme: 'grid',
            headStyles: { 
                fillColor: [200, 200, 200], 
                textColor: 0,
                fontSize: 8,
                fontStyle: 'bold'
            },
            bodyStyles: {
                fontSize: 8,
                textColor: 0
            },
            columnStyles: {
                0: { cellWidth: 30, halign: 'center' },  // S.No
                1: { cellWidth: 200 },                    // Investigation Name
                2: { cellWidth: 190 }                     // Notes
            },
            margin: { left: leftSectionWidth + 15, right: margin },
            tableWidth: 'auto'
        });
    }

    // ================= H. Footer Section =================
    const footerY = pageHeight - 60;
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.text("Doctor's Signature: _________________", leftSectionWidth + 15, footerY);
    if (data.nextVisitDays) {
      doc.text(
        `Next Visit After: ${data.nextVisitDays} Days`,
        leftSectionWidth + 15,
        footerY + 18
      );
    }
    
    doc.text(`Printed On: ${getCurrentDateTime()}`, leftSectionWidth + 250, footerY);

    // ================= I. Open PDF =================
    window.open(doc.output('bloburl'), '_blank');
};



const formatDateDDMMYYYY = (dateString) => {
  if (!dateString) return '';
  try {
      const date = new Date(dateString);
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const yyyy = date.getFullYear();
      return `${dd}-${mm}-${yyyy}`;
  } catch (e) {
      return dateString;
  }
};

  // ============================================
  // IMAGE URL TO BASE64
  // ============================================
  const imageUrlToBase64 = async (url) => {
    if (!url) return null;
    try {
      const response = await fetch(url);
      if (!response.ok) return null;
      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.error("Error converting image to Base64:", error);
      return null;
    }
  };

  // ============================================
  // HELPER FUNCTIONS
  // ============================================
  
  function parseToLocalDate(dtStr) {
    if (!dtStr) return null;
    const s = String(dtStr).trim();
    if (s instanceof Date) return s;
    
    if (/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(?:\.\d+)?(?:Z|[+-]\d{2}:?\d{2})?$/.test(s)) {
      const d = new Date(s);
      return isNaN(d.getTime()) ? null : d;
    }
    
    const mysqlLike = s.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}):?(\d{2})?)?$/);
    if (mysqlLike) {
      const year = parseInt(mysqlLike[1], 10);
      const month = parseInt(mysqlLike[2], 10) - 1;
      const day = parseInt(mysqlLike[3], 10);
      const hour = mysqlLike[4] ? parseInt(mysqlLike[4], 10) : 0;
      const minute = mysqlLike[5] ? parseInt(mysqlLike[5], 10) : 0;
      const second = mysqlLike[6] ? parseInt(mysqlLike[6], 10) : 0;
      const d = new Date(year, month, day, hour, minute, second);
      return isNaN(d.getTime()) ? null : d;
    }
    
    const d = new Date(s);
    return isNaN(d.getTime()) ? null : d;
  }

  function formatDateTime(dtStr) {
    const d = parseToLocalDate(dtStr);
    if (!d) return '';
    const dd = String(d.getDate()).padStart(2, "0");
    const months = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    const mon = months[d.getMonth()];
    const yyyy = d.getFullYear();
    let hh = d.getHours();
    const ampm = hh >= 12 ? "PM" : "AM";
    hh = hh % 12;
    if (hh === 0) hh = 12;
    const mm = String(d.getMinutes()).padStart(2, "0");
    return `${dd}-${mon}-${yyyy} ${String(hh).padStart(2, "0")}:${mm} ${ampm}`;
  }

  function getDoctorNameById(id) {
    if (id === null || id === undefined || id === "") return "Doctor not found";
    const idStr = String(id).trim();
    const doctor = (formData.doc || []).find(doc => {
      const docId = doc?.user_id ?? doc?.id ?? "";
      return String(docId).trim() === idStr;
    });
    if (!doctor) return "Doctor not found";
    const fullName = [doctor.fname, doctor.lname].filter(Boolean).join(" ");
    return fullName || doctor.fname || "Doctor";
  }

  function resolveDoctorLabel(row) {
    if (!row) return 'N/A';
    const explicit = row.opd_concult_doctor_name || row.consult_doctor_name || row.opd_refer_doctor_name || row.doctor_name;
    if (explicit && String(explicit).trim() !== '') return String(explicit).trim();
    
    const id = (row.opd_concult_doctor ?? row.opd_refer_doctor ?? row.doctor_id ?? '').toString();
    if (id && doctorsMap && doctorsMap[id]) return doctorsMap[id];
    
    if (Array.isArray(formData.doc)) {
      const candidate = formData.doc.find(d => {
        if (!d) return false;
        const keys = [
          d.user_id, d.id, d.userId, d.doctor_id, d.doc?.doc_parent, d.doc?.doc_user, d.doc?.doc_id
        ].map(x => x === undefined || x === null ? '' : String(x).trim().toLowerCase());
        return keys.includes(id.trim().toLowerCase());
      });
      if (candidate) return (candidate.fname || candidate.name || candidate.full_name || candidate.doc?.doc_name || id).toString();
    }
    
    return id || 'N/A';
  }

  // ============================================
  // DATA LOADING FUNCTIONS
  // ============================================
  
  const initData2 = async () => {
    try {
      // Check if user is a doctor
      const storedData = sessionStorage.getItem("ldata");
      let userType = '';
      let userId = '';
      
      if (storedData) {
        const parsedData = JSON.parse(storedData);
        userType = parsedData?.type || '';
        userId = parsedData?.user_id || '';
        
        // Set doctor login flags
        if (userType === 'doctor') {
          setIsDoctorLogin(true);
          setLoggedDoctorId(String(userId));
          setSelectedDoctorFilter(String(userId)); // Auto-select logged doctor
        }
      }
  
      const fd = new FormData();
      fd.append('type', 'doctor');
      fd.append('page_no', 'none');
      fd.append('user_cre_by', 'all');
      
      const response = await axios.post(
        AppConst.BASE_URL + AppConst.getUserListUrl,
        fd,
        { headers: { 'Content-Type': 'multipart/form-data' } }
      );
      
      if (response?.data?.status && Array.isArray(response.data.records)) {
        const doctors = response.data.records;
        setFormData(prev => ({ ...prev, doc: doctors }));
      }
    } catch (err) {
      console.error("initData2 error", err);
    }
  };
  

  const initVitals = async () => {
    try {
      const fd = new FormData();
      fd.append('cat_type', 'vital');
      fd.append('page_no', 'none');
      fd.append('search_key', '');
      fd.append('par_by', '1');
      
      const response = await axios.post(AppConst.BASE_URL + AppConst.getCatListUrl, fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      
      if (response.data.status) {
        const records = response.data.records;
        if (records != null && records != undefined) {
          setFormData(prev => ({
            ...prev,
            vitals: records
          }));
        }
      }
    } catch (error) {
      console.error("Error loading vitals:", error);
    }
  };

  const lastResponseRef = useRef({ page: null, recordsHash: null });

  const initData = async (opts = {}) => {
    const p = opts.page ?? pageNo;
    const size = opts.size ?? pageSize;
  
    const sendRequest = async (useOneBased = false) => {
      const fd = new FormData();
      const serverPage = useOneBased ? (p + 1) : p;
      fd.append('page_no', String(serverPage));
      fd.append('page_size', String(size));
      fd.append('search_key', formData.search_key + "");
      if (formData.from) fd.append('from', formData.from);
      if (formData.to) fd.append('to', formData.to);
      
      // ✅ ADD DOCTOR FILTER
      if (selectedDoctorFilter) {
        fd.append('doctor_id', selectedDoctorFilter);
      }
  
      try {
        const response = await axios.post(AppConst.BASE_URL + AppConst.getOpdListUrl, fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
  
        if (response?.data && response.data.status) {
          const records = response.data.records || [];
          const recordsHash = records.map(r => r.opd_id).join('|');
          const last = lastResponseRef.current;
  
          if (!useOneBased && last.recordsHash && last.recordsHash === recordsHash && p > 0) {
            const retryResponse = await sendRequest(true);
            return retryResponse;
          }
  
          setFormData(prev => ({ ...prev, l1: records }));
  
          if (typeof response.data.total !== 'undefined') {
            setTotalCount(Number(response.data.total) || 0);
          }
          if (typeof response.data.page_size !== 'undefined') {
            setPageSize(Number(response.data.page_size) || size);
          }
  
          lastResponseRef.current = { page: serverPage, recordsHash };
          setPageNo(p);
  
          return { success: true, recordsLength: records.length, data: response.data };
        } else {
          setFormData(prev => ({ ...prev, l1: [] }));
          setTotalCount(0);
          return { success: false };
        }
      } catch (err) {
        console.error("Error fetching OPD list", err);
        setFormData(prev => ({ ...prev, l1: [] }));
        setTotalCount(0);
        return { success: false, error: err };
      }
    };
  
    await sendRequest(false);
  };

  const fetchConfigData = async () => {
    try {
      const res = await axios.post(`${AppConst.BASE_URL + AppConst.getconfig}?config_type=lab`);
      if (res.data.status) {
        const data = res.data;
        setHeaderLogo(data.header_logo);
        setWatermarkLogo(data.logo || '');
        setFooterImage(data.footer_logo);
      }
    } catch (err) {
      console.error("Error fetching config:", err);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  useEffect(() => {
    const loadAll = async () => {
      const storedData = sessionStorage.getItem("ldata");
      if (storedData) setLdata(JSON.parse(storedData));
      await fetchConfigData();
      await initData2();
      await initVitals();
      await initData();
    };
    loadAll();
  }, []);

  const displayedRows = useMemo(() => {
    let list = formData.l1 || [];
    const sKey = (formData.search_key || '').trim().toLowerCase();
  
    // Basic text search
    if (sKey !== "") {
      list = list.filter(item =>
        (`${item.opd_uhid || ''}`).toLowerCase().includes(sKey) ||
        (`#453454${item.opd_id || ''}`).toLowerCase().includes(sKey) ||
        (`${item.opd_patient_mobile || ''}`).toLowerCase().includes(sKey) ||
        (`${item.opd_patient_name || ''}`).toLowerCase().includes(sKey)
      );
    }
  
    // Date range filter
    const fromRaw = formData.from ? String(formData.from).trim() : "";
    const toRaw = formData.to ? String(formData.to).trim() : "";
    let fromStart = null;
    let toEnd = null;
  
    if (fromRaw) {
      const parsedFrom = parseToLocalDate(fromRaw);
      if (parsedFrom) {
        fromStart = new Date(
          parsedFrom.getFullYear(),
          parsedFrom.getMonth(),
          parsedFrom.getDate(),
          0, 0, 0, 0
        ).getTime();
      }
    }
  
    if (toRaw) {
      const parsedTo = parseToLocalDate(toRaw);
      if (parsedTo) {
        toEnd = new Date(
          parsedTo.getFullYear(),
          parsedTo.getMonth(),
          parsedTo.getDate(),
          23, 59, 59, 999
        ).getTime();
      }
    }
  
    if (fromStart !== null || toEnd !== null) {
      list = list.filter(item => {
        if (!item.opd_datetime) return false;
        const recDate = parseToLocalDate(item.opd_datetime);
        if (!recDate) return false;
        const recTime = recDate.getTime();
  
        if (fromStart !== null && recTime < fromStart) return false;
        if (toEnd !== null && recTime > toEnd) return false;
        return true;
      });
    }
  
    // ✅ DOCTOR FILTER - Client-side (if backend doesn't filter)
    const selectedDoc = (selectedDoctorFilter || "").toString().trim();
    if (selectedDoc !== "") {
      list = list.filter(item => {
        const candidateIds = [
          item.opd_concult_doctor,
          item.opd_refer_doctor,
          item.doctor_id,
          item.opd_doc_id,
          item.doc?.doc_parent
        ].map(x => x === undefined || x === null ? "" : String(x).trim());
  
        const candidateNames = [
          item.consult_doctor_name,
          item.opd_concult_doctor_name,
          item.opd_refer_doctor_name,
          item.doctor_name,
          item.opd_doc_name
        ].map(x => x === undefined || x === null ? "" : String(x).trim().toLowerCase());
  
        // Exact id match
        if (candidateIds.some(id => id === selectedDoc)) return true;
  
        // Exact name match or includes
        if (candidateNames.some(n => n === selectedDoc.toLowerCase() || n.includes(selectedDoc.toLowerCase()))) return true;
  
        // Fallback: doctorsMap lookup
        if (doctorsMap && doctorsMap[selectedDoc] === selectedDoc) return true;
  
        return false;
      });
    }
  
    return list;
  }, [formData.l1, formData.search_key, formData.from, formData.to, selectedDoctorFilter, doctorsMap]);
  
  useEffect(() => {
    let totalAmount = 0, discountAmount = 0, paidAmount = 0, dueAmount = 0, totalCharges = 0;
    displayedRows.forEach(item => {
      totalAmount += parseFloat(item.opd_final_amt || 0);
      discountAmount += parseFloat(item.opd_discount || 0);
      paidAmount += parseFloat(item.opd_paid || 0);
      dueAmount += parseFloat(item.opd_due || 0);
      totalCharges += parseFloat(item.opd_reg_fees || 0);
    });
    setTotals({ totalAmount, discountAmount, paidAmount, dueAmount, totalCharges });
  }, [displayedRows]);

  const columns = [


    {
      name: 'Status',
      cell: row => {
        const isDone = row.done === 1 || row.done === '1' || row.done === true;
        
        if (isDone) {
          return (
            <div className="d-flex align-items-center">
              <span className="badge bg-success px-3 py-2">
                <i className="ri-check-double-line me-1"></i>
                Done
              </span>
            </div>
          );
        } else {
          return (
            <div className="d-flex align-items-center">
              <span className="badge bg-warning text-dark px-3 py-2">
                <i className="ri-time-line me-1"></i>
                Pending
              </span>
            </div>
          );
        }
      },
      sortable: true,
      width: '120px',
      center: true
    },
    {
      name: 'Prescription',
      cell: row => {
        const isDone = row.done === 1 || row.done === '1' || row.done === true;
        
        return (
          <button
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              openPrescriptionModal(row);
            }}
            className={`btn btn-sm ${isDone ? 'btn-info' : 'btn-primary'}`}
            style={{ minWidth: '150px' }}
            title={isDone ? 'Edit existing prescription' : 'Add new prescription'}
          >
            <i className={`${isDone ? 'ri-edit-line' : 'ri-add-line'} me-1`}></i>
            {isDone ? 'Edit Prescription' : 'Add Prescription'}
          </button>
        );
      },
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      width: '180px'
    },
    {
      name: 'Sn.',
      cell: (row, rowIndex) => {
        const zeroBasedPage = Number(pageNo) || 0;
        const size = Number(pageSize) || 15;
        const serial = zeroBasedPage * size + (rowIndex + 1);
        return <div>{serial}</div>;
      },
      width: '60px',
      sortable: false
    },
    { name: 'UHID', selector: row => row.opd_uhid, sortable: true, width: '130px' },
    { name: 'Reg. Number', selector: row => row.opd_id, sortable: true, width: '120px' },
    { name: 'Reg. Date', selector: row => formatDateTime(row.opd_datetime), sortable: true, width: '190px' },
    {
      name: 'Patient Name',
      selector: row => `${row.opd_patient_title || ''} ${row.opd_patient_name || ''}`.trim(),
      sortable: true,
      width: '170px'
    },
    {
      name: 'Consult Doctor',
      selector: row => row.consult_doctor_name || getDoctorNameById(row.opd_concult_doctor),
      sortable: true,
      wrap: true,
      width: '190px'
    },
    { name: 'OPD Total', selector: row => row.opd_final_amt, right: true, width: '110px' },
    { name: 'Paid Amount', selector: row => row.opd_paid, right: true, width: '110px' },
    { name: 'Due Amount', selector: row => row.opd_due, right: true, width: '110px' },
    {
      name: 'Status',
      selector: row => row.opd_type,
      cell: row => <span>{row.opd_type}</span>
    },
  ];

  const rows = displayedRows;

  const conditionalRowStyles = [
    {
      when: row => row.opd_type === "Move to IPD",
      style: {
        backgroundColor: '#caefd3ff',
      },
    },
  ];

  const customStyles = {
    headCells: {
      style: {
        backgroundColor: '#f1f5fb',
        color: '#405189',
        fontSize: '15px',
        fontWeight: '700',
        paddingLeft: '14px',
        paddingRight: '14px',
      }
    },
    rows: {
      style: {
        fontSize: '16px',
        minHeight: '58px',
      },
    },
    cells: {
      style: {
        paddingLeft: '14px',
        paddingRight: '14px',
        fontSize: '15px',
        lineHeight: '25px'
      }
    },
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="page-title-box d-sm-flex align-items-center justify-content-between">
              <h4 className="mb-sm-0" style={{ color: "#405189" }}>OPD Digital Prescription Registrations</h4>
              <div className="page-title-right">
                <button
                  className="btn btn-success"
                  onClick={(e) => {
                    e.preventDefault();
                    sessionStorage.removeItem("opd_dt");
                    window.location.href = "/opd_registrations";
                  }}
                >
                  <i className="ri-add-line align-bottom me-1"></i> New Entry
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-2">
            <label className="form-label">From</label>
            <input
              type="date"
              className="form-control"
              name="from"
              onChange={(e) => {
                const val = e.target.value;
                setFormData(prev => ({ ...prev, from: val }));
                setTimeout(() => initData(), 80);
              }}
              value={formData.from}
            />
          </div>
          <div className="col-md-2">
            <label className="form-label">To</label>
            <input
              type="date"
              className="form-control"
              name="to"
              onChange={(e) => {
                const val = e.target.value;
                setFormData(prev => ({ ...prev, to: val }));
                setTimeout(() => initData(), 80);
              }}
              value={formData.to}
            />
          </div>
          <div className="col-md-1">
            <label className="form-label">&nbsp;</label>
            <button
              onClick={() => {
                setFormData(prev => ({
                  ...prev,
                  search_key: "",
                  from: todayDate,
                  to: todayDate,
                }));
                setTimeout(initData, 100);
              }}
              className="btn btn-info d-block w-100"
            >
              Clear
            </button>
          </div>
          <div className="col-md-3" style={{ zIndex: 1050 }}>
  <label className="form-label">Filter by Doctor</label>
  <Select
    options={doctorOptions}
    value={
      doctorOptions.find(
        opt => String(opt.value) === String(selectedDoctorFilter)
      ) || null
    }
    onChange={(selectedOption) => {
      if (isDoctorLogin) return; // 🔒 Prevent change if doctor is logged in
      setSelectedDoctorFilter(selectedOption ? selectedOption.value : '');
      setTimeout(() => initData(), 100);
    }}
    placeholder={isDoctorLogin ? "Doctor (Locked)" : "All Doctors"}
    isClearable={!isDoctorLogin} // 🔒 Disable clear if doctor login
    isSearchable={!isDoctorLogin} // 🔒 Disable search if doctor login
    isDisabled={isDoctorLogin} // 🔒 Disable entire dropdown if doctor login
    styles={{
      control: (provided, state) => ({ 
        ...provided, 
        minHeight: '38px',
        backgroundColor: isDoctorLogin ? '#e9ecef' : 'white', // Gray background when locked
        cursor: isDoctorLogin ? 'not-allowed' : 'default',
        opacity: isDoctorLogin ? 0.7 : 1
      }),
      menu: (base) => ({ 
        ...base, 
        zIndex: 9999 
      })
    }}
  />
  {isDoctorLogin && (
    <small className="text-muted d-block mt-1">
      <i className="ri-lock-line me-1"></i>
      Showing only your patients
    </small>
  )}
</div>
          <div className="col-md-4">
            <label className="form-label">Search</label>
            <input
              type="text"
              className="form-control"
              placeholder="Search by UHID, Name, Mobile, Reg No..."
              name="search_key"
              onChange={(e) => setFormData(prev => ({ ...prev, search_key: e.target.value }))}
              value={formData.search_key}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            <div className="card">
              <div className="card-body">
                <DataTable
                  columns={columns}
                  data={rows}
                  pagination
                  paginationServer
                  paginationTotalRows={totalCount}
                  paginationDefaultPage={pageNo + 1}
                  paginationPerPage={pageSize}
                  onChangePage={(newPage) => {
                    const zeroBased = Math.max(0, newPage - 1);
                    setPageNo(zeroBased);
                    initData({ page: zeroBased, size: pageSize });
                  }}
                  onChangeRowsPerPage={(newPerPage, newPage) => {
                    const zeroBased = Math.max(0, (newPage ? newPage - 1 : 0));
                    setPageSize(newPerPage);
                    setPageNo(zeroBased);
                    initData({ page: zeroBased, size: newPerPage });
                  }}
                  highlightOnHover
                  conditionalRowStyles={conditionalRowStyles}
                  customStyles={customStyles}
                  persistTableHead
                />

                <div className="mt-3 text-end">
                  <strong>
                    Total Amount: {totals.totalAmount.toFixed(2)} | 
                    Discount Amount: {totals.discountAmount.toFixed(2)} | 
                    Paid Amount: {totals.paidAmount.toFixed(2)} | 
                    Due Amount: {totals.dueAmount.toFixed(2)} | 
                    Total Register Charges: {totals.totalCharges.toFixed(2)}
                  </strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* PRESCRIPTION MODAL - FULL SCREEN */}
        <Modal
          show={showPrescriptionModal}
          onHide={closePrescriptionModal}
          fullscreen={true}
          centered
          style={{ zIndex: 9990 }} 
        >
          <Modal.Header closeButton style={{ backgroundColor: '#f8f9fa', borderBottom: '2px solid #dee2e6' }}>
            <Modal.Title>
              <i className="ri-file-list-3-line me-2"></i>
              Add Prescription - {selectedPatient?.opd_patient_name || 'Patient'}
            </Modal.Title>
            <div className="ms-auto me-3">
              <button
                type="button"
                className="btn btn-success me-2"
                onClick={savePrescription}
              >
                <i className="ri-save-line me-1"></i>
                Save Prescription
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={printPrescription}
                disabled={!isPrescriptionSaved}
              >
                <i className="ri-printer-line me-1"></i>
                Print Prescription
              </button>&nbsp;&nbsp;
              <button
        type="button"
        className="btn btn-danger"
        onClick={closePrescriptionModal}
      >
        <i className="ri-close-line me-1"></i>
        Close
      </button>
            </div>
          </Modal.Header>
          
          <Modal.Body style={{ padding: '20px', backgroundColor: '#f8f9fa' }}>
            <Tabs
              activeKey={activeTab}
              onSelect={(k) => setActiveTab(k)}
              className="mb-3"
            >
              {/* PATIENT DETAILS TAB */}
              <Tab eventKey="patient" title={<span><i className="ri-user-line me-2"></i>Patient Details</span>}>
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label fw-bold text-primary">
                            <i className="ri-barcode-line me-1"></i>UHID:
                          </label>
                          <p className="form-control-plaintext fs-5">{selectedPatient?.opd_uhid || 'N/A'}</p>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label fw-bold text-primary">
                            <i className="ri-hospital-line me-1"></i>Reg. Number:
                          </label>
                          <p className="form-control-plaintext fs-5">{selectedPatient?.opd_id || 'N/A'}</p>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label fw-bold text-primary">
                            <i className="ri-user-3-line me-1"></i>Patient Name:
                          </label>
                          <p className="form-control-plaintext fs-5">
                            {`${selectedPatient?.opd_patient_title || ''} ${selectedPatient?.opd_patient_name || ''}`.trim()}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-3">
                        <div className="mb-3">
                          <label className="form-label fw-bold text-primary">
                            <i className="ri-calendar-line me-1"></i>Age/Gender:
                          </label>
                          <p className="form-control-plaintext fs-5">
                            {selectedPatient?.opd_guardien_age || 'N/A'} / {selectedPatient?.opd_patient_gender || 'N/A'}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label fw-bold text-primary">
                            <i className="ri-phone-line me-1"></i>Mobile:
                          </label>
                          <p className="form-control-plaintext fs-5">{selectedPatient?.opd_patient_mobile || 'N/A'}</p>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label fw-bold text-primary">
                            <i className="ri-map-pin-line me-1"></i>Address:
                          </label>
                          <p className="form-control-plaintext fs-5">{selectedPatient?.opd_address || 'N/A'}</p>
                        </div>
                      </div>
                      <div className="col-md-4">
                        <div className="mb-3">
                          <label className="form-label fw-bold text-primary">
                            <i className="ri-stethoscope-line me-1"></i>Consultant Doctor:
                          </label>
                          <p className="form-control-plaintext fs-5">
                            {selectedPatient?.consult_doctor_name || getDoctorNameById(selectedPatient?.opd_concult_doctor)}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Tab>

              {/* VITALS TAB */}
              <Tab eventKey="vitals" title={<span><i className="ri-heart-pulse-line me-2"></i>Vitals</span>}>
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="mb-0 text-primary">
                        <i className="ri-heart-pulse-fill me-2"></i>Vital Signs
                      </h5>
                      <button type="button" onClick={addVitalRow} className="btn btn-primary">
                        <i className="ri-add-line me-1"></i> Add Vital
                      </button>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-bordered table-hover">
                        <thead className="table-primary">
                          <tr>
                            <th style={{ width: '80px' }}>S.No</th>
                            <th>Vital Name</th>
                            <th>Value</th>
                            <th style={{ width: '120px' }}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {prescriptionData.vitals.map((vital, index) => (
                            <tr key={index}>
                              <td className="text-center fw-bold">{index + 1}</td>
                              <td>
                                <select
                                  className="form-control"
                                  value={vital.vital_name}
                                  onChange={(e) => handleVitalChange(index, 'vital_name', e.target.value)}
                                >
                                  <option value="">Select Vital</option>
                                  {formData.vitals && formData.vitals.map((v, idx) => (
                                    <option key={idx} value={v.cat_id}>{v.cat_name}</option>
                                  ))}
                                </select>
                              </td>
                              <td>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter value"
                                  value={vital.vital_value}
                                  onChange={(e) => handleVitalChange(index, 'vital_value', e.target.value)}
                                />
                              </td>
                              <td className="text-center">
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => removeVitalRow(index)}
                                  disabled={prescriptionData.vitals.length === 1}
                                >
                                  <i className="ri-delete-bin-line me-1"></i>Delete
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </Tab>

              {/* COMPLAINTS TAB */}
              <Tab eventKey="complaints" title={<span><i className="ri-chat-3-line me-2"></i>Complaints</span>}>
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="mb-0 text-primary">
                        <i className="ri-chat-3-fill me-2"></i>Patient Complaints
                      </h5>
                      <button type="button" onClick={addComplaintRow} className="btn btn-primary">
                        <i className="ri-add-line me-1"></i> Add Complaint
                      </button>
                    </div>
                    <div className="table-responsive">
                      <table className="table table-bordered table-hover">
                        <thead className="table-primary">
                          <tr>
                            <th style={{ width: '80px' }}>S.No</th>
                            <th>Complaint</th>
                            <th style={{ width: '120px' }}>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {prescriptionData.complaints.map((complaint, index) => (
                            <tr key={index}>
                              <td className="text-center fw-bold">{index + 1}</td>
                              <td>
                                <textarea
                                  className="form-control"
                                  rows="2"
                                  placeholder="Enter complaint"
                                  value={complaint.complaint_text}
                                  onChange={(e) => handleComplaintChange(index, e.target.value)}
                                />
                              </td>
                              <td className="text-center">
                                <button
                                  type="button"
                                  className="btn btn-danger btn-sm"
                                  onClick={() => removeComplaintRow(index)}
                                  disabled={prescriptionData.complaints.length === 1}
                                >
                                  <i className="ri-delete-bin-line me-1"></i>Delete
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </Tab>

              {/* MEDICINE TAB */}
              <Tab eventKey="medicine" title={<span><i className="ri-capsule-line me-2"></i>Medicine</span>}>
  <div className="card">
    <div className="card-body">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0 text-primary">
          <i className="ri-capsule-fill me-2"></i>Medicines
        </h5>
        <button type="button" onClick={addMedicineRow} className="btn btn-primary">
          <i className="ri-add-line me-1"></i> Add Medicine
        </button>
      </div>
      
      <div className="table-responsive">
        <table className="table table-bordered table-hover">
          <thead className="table-primary">
            <tr>
              <th style={{ width: '50px' }}>S.No</th>
              <th style={{ width: '280px' }}>Medicine Name</th>
              <th style={{ width: '100px' }}>Batch</th>
              <th style={{ width: '100px' }}>Expiry</th>
              <th style={{ width: '70px' }}>Mrng</th>
              <th style={{ width: '70px' }}>Noon</th>
              <th style={{ width: '70px' }}>Evng</th>
              <th style={{ width: '70px' }}>Night</th>
              <th style={{ width: '70px' }}>Days</th>
              <th style={{ width: '70px' }}>Qty</th>
              <th style={{ width: '130px' }}>Start Date</th>
              <th style={{ width: '130px' }}>End Date</th>
              <th style={{ width: '100px' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {prescriptionData.medicines.map((medicine, index) => (
              <tr key={index}>
                <td className="text-center fw-bold">{index + 1}</td>
                <td>
                  <Select
                    className="medicine-select"
                    options={medicineOptions}
                    value={medicineOptions.find(opt => opt.label === medicine.medicine_name) || null}
                    onChange={(selected) => handleMedicineSelectChange(selected, index)}
                    placeholder="Search medicine..."
                    isClearable
                    isSearchable
                    menuPortalTarget={document.body}
                    styles={{
                      control: (provided) => ({ 
                        ...provided, 
                        minHeight: '38px',
                        borderRadius: 4
                      }),
                      menuPortal: (base) => ({ 
                        ...base, 
                        zIndex: 9999 
                      }),
                      menu: (base) => ({ 
                        ...base, 
                        maxHeight: '300px' 
                      }),
                      menuList: (base) => ({ 
                        ...base, 
                        maxHeight: '280px' 
                      }),
                      option: (provided) => ({ 
                        ...provided, 
                        padding: '10px 12px',
                        minHeight: '50px'
                      })
                    }}
                    formatOptionLabel={(option) => (
                      <div>
                        <div><strong>{option.label}</strong></div>
                        <small className="text-muted">
                          Batch: <span style={{ color: "#0d6efd" }}>{option.batch}</span> | 
                          Stock: <span style={{ color: "#198754" }}>{option.stock}</span>
                        </small>
                      </div>
                    )}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    className="form-control"
                    value={medicine.batch}
                    readOnly
                    style={{ backgroundColor: '#f8f9fa' }}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    className="form-control"
                    value={medicine.expiry}
                    readOnly
                    style={{ backgroundColor: '#f8f9fa' }}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    step="0.5"
                    min="0"
                    className="form-control"
                    placeholder="0"
                    value={medicine.morning}
                    onChange={(e) => handleMedicineChange(index, 'morning', e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    step="0.5"
                    min="0"
                    className="form-control"
                    placeholder="0"
                    value={medicine.noon}
                    onChange={(e) => handleMedicineChange(index, 'noon', e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    step="0.5"
                    min="0"
                    className="form-control"
                    placeholder="0"
                    value={medicine.evening}
                    onChange={(e) => handleMedicineChange(index, 'evening', e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    step="0.5"
                    min="0"
                    className="form-control"
                    placeholder="0"
                    value={medicine.night}
                    onChange={(e) => handleMedicineChange(index, 'night', e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="number"
                    min="1"
                    className="form-control"
                    placeholder="Days"
                    value={medicine.days}
                    onChange={(e) => handleMedicineChange(index, 'days', e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="text"
                    className="form-control text-center fw-bold"
                    value={medicine.qty}
                    readOnly
                    style={{ backgroundColor: '#d4edda', color: '#155724', fontSize: '16px' }}
                  />
                </td>
                <td>
                  <input
                    type="date"
                    className="form-control"
                    value={medicine.start_date}
                    onChange={(e) => handleMedicineChange(index, 'start_date', e.target.value)}
                  />
                </td>
                <td>
                  <input
                    type="date"
                    className="form-control"
                    value={medicine.end_date}
                    readOnly
                    style={{ backgroundColor: '#f8f9fa' }}
                  />
                </td>
                <td className="text-center">
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={() => removeMedicineRow(index)}
                    disabled={prescriptionData.medicines.length === 1}
                  >
                    <i className="ri-delete-bin-line"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      <div className="alert alert-info mt-3">
        <h6 className="alert-heading">
          <i className="ri-information-line me-2"></i>How to use:
        </h6>
        <ul className="mb-0">
          <li>Select medicine from dropdown (searches by name)</li>
          <li>Enter dosage for <strong>Morning, Noon, Evening, Night</strong> (e.g., 1, 0.5, 0)</li>
          <li>Enter number of <strong>Days</strong></li>
          <li><strong>Quantity</strong> auto-calculates: (M + N + E + Nt) × Days</li>
          <li><strong>End date</strong> auto-calculates from Start date + Days</li>
        </ul>
      </div>
    </div>
  </div>
</Tab>


<Tab eventKey="investigation" title={<span><i className="ri-test-tube-line me-2"></i>Investigation</span>}>
  <div className="card">
    <div className="card-body">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h5 className="mb-0 text-primary">
          <i className="ri-test-tube-fill me-2"></i>Investigations
        </h5>
        <button type="button" onClick={addInvestigationRow} className="btn btn-primary">
          <i className="ri-add-line me-1"></i> Add Investigation
        </button>
      </div>
      
      <div className="table-responsive">
        <table className="table table-bordered table-hover">
          <thead className="table-primary">
            <tr>
              <th style={{ width: '80px' }}>S.No</th>
              <th style={{ width: '350px' }}>Investigation Name</th>
              <th>Notes</th>
              <th style={{ width: '120px' }}>Action</th>
            </tr>
          </thead>
          <tbody>
            {prescriptionData.investigations.map((investigation, index) => (
              <tr key={index}>
                <td className="text-center fw-bold">{index + 1}</td>
                <td>
                  <Select
                    className="investigation-select"
                    options={investigationOptions}
                    value={investigationOptions.find(opt => opt.value === investigation.investigation_id) || null}
                    onChange={(selected) => handleInvestigationSelectChange(selected, index)}
                    placeholder="Search investigation..."
                    isClearable
                    isSearchable
                    menuPortalTarget={document.body}
                    styles={{
                      control: (provided) => ({ 
                        ...provided, 
                        minHeight: '38px',
                        borderRadius: 4
                      }),
                      menuPortal: (base) => ({ 
                        ...base, 
                        zIndex: 9999 
                      }),
                      menu: (base) => ({ 
                        ...base, 
                        maxHeight: '300px' 
                      }),
                      menuList: (base) => ({ 
                        ...base, 
                        maxHeight: '280px' 
                      }),
                      option: (provided) => ({ 
                        ...provided, 
                        padding: '10px 12px',
                        minHeight: '45px'
                      })
                    }}
                    formatOptionLabel={(option) => (
                      <div>
                        <div><strong>{option.label}</strong></div>
                        {option.category && (
                          <small className="text-muted">
                            Category: <span style={{ color: "#0d6efd" }}>{option.category}</span>
                          </small>
                        )}
                      </div>
                    )}
                  />
                </td>
                <td>
                  <textarea
                    className="form-control"
                    rows="2"
                    placeholder="Additional notes"
                    value={investigation.notes}
                    onChange={(e) => handleInvestigationChange(index, 'notes', e.target.value)}
                  />
                </td>
                <td className="text-center">
                  <button
                    type="button"
                    className="btn btn-danger btn-sm"
                    onClick={() => removeInvestigationRow(index)}
                    disabled={prescriptionData.investigations.length === 1}
                  >
                    <i className="ri-delete-bin-line me-1"></i>Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      
      <div className="alert alert-info mt-3">
        <h6 className="alert-heading">
          <i className="ri-information-line me-2"></i>Note:
        </h6>
        <p className="mb-0">
          Select investigations from the dropdown. You can add additional notes for each investigation if needed.
        </p>
      </div>
    </div>
  </div>
</Tab>


<Tab
  eventKey="nextvisit"
  title={<span><i className="ri-calendar-event-line me-2"></i>Next Visit</span>}
>
  <div className="card">
    <div className="card-body">
      <h5 className="text-primary mb-3">
        <i className="ri-calendar-check-line me-2"></i>
        Next Visit Schedule
      </h5>

      <div className="row">
        <div className="col-md-4">
          <label className="form-label fw-bold">
            Next Visit After (Days)
          </label>
          <input
            type="number"
            min="1"
            className="form-control"
            placeholder="Enter days (e.g. 30)"
            value={prescriptionData.next_visit_days}
            onChange={(e) =>
              setPrescriptionData(prev => ({
                ...prev,
                next_visit_days: e.target.value
              }))
            }
          />
        </div>

        {prescriptionData.next_visit_days && (
          <div className="col-md-8 mt-4">
            <div className="alert alert-info">
              <strong>Next Visit Date:</strong>{" "}
              {(() => {
                const d = new Date();
                d.setDate(d.getDate() + parseInt(prescriptionData.next_visit_days));
                return formatDateDDMMYYYY(d);
              })()}
            </div>
          </div>
        )}
      </div>
    </div>
  </div>
</Tab>

            </Tabs>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}

export default OpdPataintList;